import styled from "styled-components";

const Img = styled.img`
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
`;

const VideoLater: React.FC = () => {
  return (
    <Wrapper>
      <Img src="https://cdn.duocards.com/img/video-list.png" />
    </Wrapper>
  );
};

export default VideoLater;
